const VK_SHARE_URL = `http://vkontakte.ru/share.php?`
const OK_SHARE_URL = `http://www.ok.ru/dk?st.cmd=addShare&st.s=1`
const FB_SHARE_URL = `http://www.facebook.com/sharer.php?s=100`

export function vkShare(url, title, text, image) {
  var shareUrl = `${VK_SHARE_URL}`
  shareUrl += `url=${encodeURIComponent(url)}`
  shareUrl += `&title=${encodeURIComponent(title)}`
  shareUrl += `&description=${encodeURIComponent(text)}`
  shareUrl += `&image=${encodeURIComponent(image)}`
  shareUrl += '&noparse=true'

  share(shareUrl)
}
export function okShare(url, title, text, image) {
  var shareUrl = `${OK_SHARE_URL}`
  shareUrl += `&st._surl=${encodeURIComponent(url)}`
  shareUrl += `&st.comments=${encodeURIComponent(title)}`
  share(shareUrl)
}

export function fbShare(url, title, text, image) {
  var shareUrl = `${FB_SHARE_URL}`
  shareUrl += `&title=${encodeURIComponent(title)}`
  shareUrl += `&description=${encodeURIComponent(text)}`
  shareUrl += `&u=${encodeURIComponent(url)}`
  shareUrl += `&picture=${encodeURIComponent(image)}`

  share(shareUrl)
}

function share(url) {
  window.open(url,'', 'toolbar=0,status=0,width=626,height=436');
}


// WEBPACK FOOTER //
// ./src/actions/ShareActions.js